const overrideKey = (storeId, userId) => `posCartOnLeftUser_${storeId}_${userId}`;
const categoryOverrideKey = (storeId, userId) => `posCategoryInMiddleUser_${storeId}_${userId}`;

export function readCartUserOverride(storeId, userId) {
  if (!storeId || !userId || typeof localStorage === "undefined") return null;
  const raw = localStorage.getItem(overrideKey(storeId, userId));
  if (raw === "1") return true;
  if (raw === "0") return false;
  return null;
}

export function writeCartUserOverride(storeId, userId, onLeft) {
  if (!storeId || !userId) return;
  localStorage.setItem(overrideKey(storeId, userId), onLeft ? "1" : "0");
}

export function resolveCartOnLeft(storeDefault, storeId, userId) {
  const override = readCartUserOverride(storeId, userId);
  if (override === null) return !!storeDefault;
  return override;
}

export function readCategoryUserOverride(storeId, userId) {
  if (!storeId || !userId || typeof localStorage === "undefined") return null;
  const raw = localStorage.getItem(categoryOverrideKey(storeId, userId));
  if (raw === "1") return true;
  if (raw === "0") return false;
  return null;
}

export function writeCategoryUserOverride(storeId, userId, inMiddle) {
  if (!storeId || !userId) return;
  localStorage.setItem(categoryOverrideKey(storeId, userId), inMiddle ? "1" : "0");
}

export function resolveCategoryInMiddle(storeDefault, storeId, userId) {
  const override = readCategoryUserOverride(storeId, userId);
  if (override === null) return !!storeDefault;
  return override;
}

export function readSignedInPosUserId(storeId) {
  if (!storeId || typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(`currentPOSUser_${storeId}`);
    if (!raw) return null;
    const user = JSON.parse(raw);
    return user?.id || null;
  } catch {
    return null;
  }
}

export function publishCartPosition(storeId, onLeft, userOverride) {
  window.dispatchEvent(new CustomEvent("posLayoutUpdated", {
    detail: {
      storeId,
      posCartOnLeft: !!onLeft,
      userOverride: !!userOverride,
    },
  }));
}

export function publishCategoryPosition(storeId, inMiddle, userOverride) {
  window.dispatchEvent(new CustomEvent("posLayoutUpdated", {
    detail: {
      storeId,
      posCategoryInMiddle: !!inMiddle,
      userOverride: !!userOverride,
    },
  }));
}
